import React, { useEffect, useMemo } from 'react'
import { CHARGING_DAYS, Day } from '@e3dc-react/shell/Libs/date/types'
import { useFormikContext } from 'formik'
import { NumberField } from 'src/Libs/inputs/formik'
import { UnitTypes } from 'src/Libs/types'
import { WallboxSettingsFormModel } from 'src/Libs/wallboxes/models'

interface Props {
  name: keyof WallboxSettingsFormModel
  weekDayName: Day
  suffix: string
}

/**
 * Display Total Charge in Combined charging strategy weekday card
 */
const ChargeStrategyTotalChargeAmountField: React.FC<Props> = ({ name, weekDayName, suffix }) => {
  const {
    values: { chargeStrategyConfiguration: configurations },
    setFieldValue,
  } = useFormikContext<WallboxSettingsFormModel>()

  const weekDayIndex = CHARGING_DAYS.indexOf(weekDayName)

  const configuration = configurations?.find(item => item.chargeStrategyWeekday === weekDayIndex)
  const delayedChargeAmount = configuration?.chargeStrategyDelayedChargeAmount ?? 0
  const directChargeAmount = configuration?.chargeStrategyDirectChargeAmount ?? 0

  const fieldProps = useMemo(
    () => ({
      name: `${name}.${weekDayIndex}.chargeStrategyTotalChargeAmount`,
      suffix,
      disabled: true,
      isDecimal: suffix === UnitTypes.kiloWattHour,
      precision: 2,
    }),
    [name, suffix, weekDayIndex]
  )

  useEffect(() => {
    const totalChargeAmount = Number(directChargeAmount) + Number(delayedChargeAmount)
    setFieldValue(`${name}.${weekDayIndex}.chargeStrategyTotalChargeAmount`, totalChargeAmount)
  }, [delayedChargeAmount, directChargeAmount, setFieldValue, weekDayIndex, name])

  return <NumberField {...fieldProps} />
}

export default ChargeStrategyTotalChargeAmountField
